import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  TYPE_PAYMENT,
  TYPE_PAYMENT_UNDERLINED,
  TYPE_UNDERLINED,
} from '../../../brands/default/constants';
import ThemeContext from '../../../providers/ThemeProvider';
import FormError from './FormError';

const WrappedInput = ({
  children,
  error,
  errorText,
  formType,
  icon,
  normal,
  showValidIconOnly = false,
  valid,
}) => {
  const theme = useContext(ThemeContext);
  const componentClass = classNames('input-container', {
    error,
    'input-container--payment': formType === TYPE_PAYMENT,
    'input-container--payment-underlined': formType === TYPE_PAYMENT_UNDERLINED,
    'input-container--underlined': formType === TYPE_UNDERLINED,
    normal,
    valid,
  });
  const showError = error && errorText;

  return (
    <>
      <div className={componentClass}>
        <div className="form-group">
          {children}

          {((icon && !showValidIconOnly) ||
            (icon && showValidIconOnly && valid)) && (
            <span className="input-container__icon">
              <FontAwesomeIcon icon={icon} style={{ height: 16, width: 16 }} />
            </span>
          )}
        </div>
        {Boolean(showError) && (
          <FormError errorText={errorText} formType={formType} />
        )}
      </div>
      <style jsx>{`
        // normal icon
        .input-container__icon {
          color: ${theme.colors.inputiconcolor};
        }
        // error icon
        .error .input-container__icon {
          color: ${theme.colors.inputinvalidcolor};
        }
        // valid icon
        .valid .input-container__icon {
          color: ${theme.colors.inputvalidcolor};
        }

        // payment green bottom border if valid
        :global(.input-container--payment.valid .form-control) {
          border-bottom-color: ${theme.colors.inputlogincolor};
        }
        // hide default drop down arrow
        :global(select) {
          appearance: none;
        }
        :global(.error .form-control) {
          border-color: ${theme.colors.inputinvalidcolor};
        }
        // payment default border if error
        :global(.input-container--payment.error .form-control) {
          border-color: ${theme.colors.inputdefaultborder};
        }
        :global(.input-container .form-control:focus) {
          border-color: ${theme.colors.inputfocuscolor};
        }
        // payment - underlined
        :global(.input-container--payment-underlined.error .form-control) {
          border-color: ${theme.colors.inputdefaultborder};
          border-bottom-color: ${theme.colors.inputinvalidcolor};
        }
        :global(.input-container--payment-underlined.valid .form-control) {
          border-bottom-color: ${theme.colors.inputlogincolor};
        }
      `}</style>
    </>
  );
};

WrappedInput.propTypes = {
  children: PropTypes.node,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorText: PropTypes.string,
  formType: PropTypes.string,
  icon: PropTypes.object,
  normal: PropTypes.bool,
  showValidIconOnly: PropTypes.bool,
  valid: PropTypes.bool,
};

export default WrappedInput;
